var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teleport",class:_vm.classes},[_c('div',{ref:"moved",staticClass:"teleported",style:(_vm.style)},[_vm._t("default",null,{"top":_vm.top,"left":_vm.left})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }